import { SET_EDITEVENT } from '../actions';

const eventedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITEVENT:
      return [...action.value];  
    default: return state;
  }
}

export default eventedit;
